import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ShieldCheck, Globe, TrendingUp } from "lucide-react";
import heroImage from "@/assets/hero-port.webp";
import DeferredYouTubeBg from "@/components/DeferredYouTubeBg";

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden min-h-[600px]">
      {/* Background YouTube loop, with image fallback for fast first paint */}
      <div className="absolute inset-0 bg-navy">
        <img
          src={heroImage}
          alt=""
          width={1920}
          height={1080}
          fetchPriority="high"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <DeferredYouTubeBg videoId="BguyZ3Wdzrg" title="Hero background" />
        </div>
        <div className="absolute inset-0 bg-navy/55" />
      </div>

      <div className="container mx-auto px-4 py-20 lg:py-28 relative z-10">
        <div className="max-w-2xl">
          {/* Content */}
          <div>
            <motion.h1
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-[1.15] mb-5"
            >
              Trade Without Borders
            </motion.h1>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="text-base lg:text-lg text-white max-w-xl mb-8 leading-relaxed"
            >
              Connecting verified businesses to sustainable trade, investment and market opportunities across Africa, Asia, the Middle East and beyond.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              className="flex flex-col sm:flex-row gap-3 mb-10"
            >
              <Link
                to="/register"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-gold text-gold-foreground font-semibold text-sm hover:opacity-90 transition-opacity rounded-md"
              >
                Become a Member <ArrowRight className="w-4 h-4" />
              </Link>
              <Link
                to="/marketplace"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border border-white/30 text-white text-sm font-medium hover:border-gold hover:text-gold transition-colors rounded-md backdrop-blur-sm"
              >
                Explore Marketplace
              </Link>
            </motion.div>

            {/* Trust badges */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.7 }}
              className="flex flex-wrap items-center gap-x-6 gap-y-3"
            >
              {[
                { icon: ShieldCheck, text: "Verified Members" },
                { icon: Globe, text: "Cross-continent reach" },
                { icon: TrendingUp, text: "Cross-border trade" },
              ].map((b) => (
                <div key={b.text} className="flex items-center gap-2 text-white/80 text-xs">
                  <b.icon size={14} className="text-gold" />
                  {b.text}
                </div>
              ))}
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
